// pages/ManageActivity.jsx

import { useState, useEffect } from "react";
import apiClient from "../../shared/API/apiClient";
import SuperAdminLayout from "../layout/SuperAdminLayout";
import "./superAdminStyle/manageActivity.css";
import Toast from "../../shared/components/Toast";
import ActivityModal from "./ActivityModal";
import { Power } from "lucide-react";
import { Link2 } from "lucide-react";
import { Eye } from "lucide-react";

const ManageActivity = ({ adminName, onLogout }) => {
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);

  const [toast, setToast] = useState(null);

  //loading state Loader
  const [loadingFields, setLoadingFields] = useState(false);

  //for pop up if data is there
  const [showOptionsModal, setShowOptionsModal] = useState(false);
  const [optionsList, setOptionsList] = useState([]);

  const [activities, setActivities] = useState([]);
  const [selectedActivity, setSelectedActivity] = useState("");

  const [fields, setFields] = useState([]);

  useEffect(() => {
    fetchActivities();
  }, []);

  //Fetch activity dropdown API

  const fetchActivities = async () => {
    try {
      const res = await apiClient.get("/api/activitytypelist");
      if (res.data.success) {
        const list = res.data.data || [];
        setActivities(list);
        if (list.length > 0) {
          setSelectedActivity(list[0].id);
        }
      }
    } catch (err) {
      console.error("Activity Type API error:", err);
    }
  };
  //FETCH Activity Listing API

  useEffect(() => {
    if (selectedActivity) {
      fetchFields(selectedActivity);
    }
  }, [selectedActivity]);

  const fetchFields = async (id) => {
    setLoadingFields(true);

    try {
      const res = await apiClient.get(`/api/activity_type/${id}`);

      if (res.data.success) {
        const sorted = (res.data.fields || []).sort(
          (a, b) => a.display_order - b.display_order
        );

        setFields(sorted);
      }
    } catch (err) {
      console.error("Fields API error:", err);
    } finally {
      setLoadingFields(false);
    }
  };

  //Status toggle API

  const handleToggleStatus = async (item) => {
    try {
      const res = await apiClient.post(
        `/api/activity_type/toggle-status/${item.id}`
      );

      if (res.data.success) {
        const newStatus = res.data.status === "active" ? "active" : "inactive";

        // state update
        setFields((prev) =>
          prev.map((f) => (f.id === item.id ? { ...f, status: newStatus } : f))
        );

        setToast({
          message:
            newStatus === "active"
              ? "Field activated successfully"
              : "Field deactivated successfully",
          type: "success",
        });
      }
    } catch (err) {
      console.error("Toggle status failed:", err);
      setToast({
        message: "Something went wrong",
        type: "error",
      });
    }
  };

  const openAdd = () => {
    setEditData(null);
    setShowModal(true);
  };

  const openEdit = (item) => {
    setEditData(item);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setEditData(null);
  };

  //selected activity
  // const selectedActivityObj = activities.find((a) => a.id == selectedActivity);

  //handle view option
  const handleViewOptions = (options) => {
    setOptionsList(options);
    setShowOptionsModal(true);
  };

  const handleSaved = () => {
    if (editData) {
      setToast({
        message: "Fields Updated successfully",
        type: "success",
      });
    } else {
      setToast({
        message: "Fields added successfully",
        type: "success",
      });
    }

    fetchFields(selectedActivity);
  };

  return (
    <SuperAdminLayout userName={adminName} onLogout={onLogout}>
      <div className="dash-page">
        <div className="le-page-header">
          <div>
            <div className="dash-page-title">Manage Activity</div>
            <div className="dash-page-subtitle">
              Manage system-defined and Activity monitoring system based on
              consumption
            </div>
          </div>
          <br></br>
          <button className="org-btn-save le-add-btn" onClick={openAdd}>
            + &nbsp;Add Fields
          </button>
        </div>

        {/* Activity Card */}
        <div className="pm-card">
          <div className="ep-card-header">
            <Link2 className="ep-card-icon" />
            <span className="ep-card-title">Select Activity Type</span>
          </div>

          <p className="pm-subtext">
            Choose the monitoring activity you want to check it for.
          </p>

          <label className="pm-label">Select Activity</label>
          <select
            className="pm-select"
            value={selectedActivity}
            onChange={(e) => setSelectedActivity(e.target.value)}
          >
            {activities.map((a) => (
              <option key={a.id} value={a.id}>
                {a.name}
              </option>
            ))}
          </select>
        </div>

        {/* Activity Fields */}
        <div className="ep-card">
          <div className="ep-card-header">
            <span className="ep-card-title">Activity Fields</span>
          </div>

          <p className="ep-card-desc">
            Activity based on Consumption. You can edit or deactivate them at
            any time.
          </p>

          <table className="le-table">
            <thead>
              <tr>
                <th>Field Key</th>
                <th>Field Label</th>
                <th>Field Type</th>
                <th>Required</th>
                <th>Options</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {loadingFields ? (
                <tr>
                  <td colSpan="7">
                    <div className="table-loader-wrap-full">
                      <div className="table-loader"></div>
                      <p className="table-loader-text">
                        Activity fields loading...
                      </p>
                    </div>
                  </td>
                </tr>
              ) : fields.length > 0 ? (
                fields.map((f) => (
                  <tr key={f.id}>
                    <td>{f.field_key || "--"}</td>
                    <td>{f.field_label || "--"}</td>
                    <td>{f.field_type || "--"}</td>
                    <td>{f.is_required ? "Yes" : "No"}</td>

                    <td>
                      {f.options && f.options.length > 0 ? (
                        <span
                          className="action-item edit"
                          onClick={() => handleViewOptions(f.options)}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                          }}
                        >
                          <Eye size={16} />
                          View Options
                        </span>
                      ) : (
                        "--"
                      )}
                    </td>

                    <td>
                      <span className="ep-status">
                        {f.status === "active" ? "Active" : "Inactive"}
                      </span>
                    </td>

                    <td>
                      <div className="le-actions">
                        <span
                          className="action-item edit"
                          onClick={() => openEdit(f)}
                        >
                          <img
                            src="https://cdn-icons-png.flaticon.com/512/1828/1828911.png"
                            alt="edit"
                            className="action-icon"
                          />
                          Edit
                        </span>

                        <span
                          className={`action-item ${
                            f.status === "active" ? "deactivate" : "activate"
                          }`}
                          onClick={() => handleToggleStatus(f)}
                        >
                          <Power size={16} />
                          {f.status === "active" ? "Deactivate" : "Activate"}
                        </span>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7">No fields available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {showOptionsModal && (
          <div className="modal-overlay">
            <div className="modal-container" style={{ width: "274px" }}>
              {/* Header */}
              <div className="modal-header" style={{ fontSize: "13px" }}>
                <h3>View Options</h3>
                <span
                  className="modal-close"
                  onClick={() => setShowOptionsModal(false)}
                >
                  ✕
                </span>
              </div>

              {/* Body */}
              <div className="modal-body">
                {optionsList.length > 0 ? (
                  <ul className="options-list">
                    {optionsList.map((opt, i) => (
                      <li key={i}>{opt?.value || "--"}</li>
                    ))}
                  </ul>
                ) : (
                  <p>No options available</p>
                )}
              </div>

              {/* Footer */}
              <div className="modal-footer">
                <button
                  className="org-btn-cancel"
                  onClick={() => setShowOptionsModal(false)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        )}

        {showModal && (
          <ActivityModal
            onClose={closeModal}
            onSaved={handleSaved}
            editData={editData}
            selectedActivity={selectedActivity}
          />
        )}

        {toast && (
          <Toast
            message={toast.message}
            type={toast.type}
            onClose={() => setToast(null)}
          />
        )}
      </div>
    </SuperAdminLayout>
  );
};

export default ManageActivity;
